import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined';
import ScienceOutlined from '@mui/icons-material/ScienceOutlined';
import GroupsOutlined from '@mui/icons-material/GroupsOutlined';
import SwapHorizOutlined from '@mui/icons-material/SwapHorizOutlined';
import WidgetsOutlined from '@mui/icons-material/WidgetsOutlined';
import BalanceOutlined from '@mui/icons-material/BalanceOutlined';

import { APPLICATION_EXAMPLES } from './landingContent';
import { LandingCard, LandingReveal, landingCaptionSx } from './LandingMotion';

const EXAMPLE_MARKS = {
  Strategy: AltRouteOutlined,
  Innovation: ScienceOutlined,
  Leadership: GroupsOutlined,
  Change: SwapHorizOutlined,
  'Product & portfolio': WidgetsOutlined,
  'Professional judgment': BalanceOutlined,
};

const ApplicationExamples = () => (
  <Box
    component="section"
    sx={{
      bgcolor: 'background.default',
      py: { xs: 8, md: 12 },
      borderTop: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Container maxWidth="lg">
      <LandingReveal>
        <Typography variant="caption" sx={landingCaptionSx}>
          Example situations
        </Typography>
        <Typography
          component="h2"
          sx={{
            mt: 1,
            mb: 1.5,
            fontWeight: 600,
            fontSize: { xs: '1.75rem', md: '2.25rem' },
            letterSpacing: '-0.02em',
            maxWidth: 480,
          }}
        >
          Where judgment matters
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 480 }}>
          Illustrative dilemmas — not customer case studies.
        </Typography>
      </LandingReveal>

      <Grid container spacing={2.5}>
        {APPLICATION_EXAMPLES.map((example, index) => (
          <Grid item xs={12} sm={6} key={example.area} sx={{ display: 'flex' }}>
            <LandingReveal index={index} sx={{ width: '100%', height: '100%' }}>
              <LandingCard
                kind="dilemma"
                mark={EXAMPLE_MARKS[example.area]}
                tone="quiet"
                title={example.area}
                body={example.situation}
                titleComponent="h3"
              />
            </LandingReveal>
          </Grid>
        ))}
      </Grid>
    </Container>
  </Box>
);

export default ApplicationExamples;
